module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"warnings":"Warnings","close":"Close","overlap":"Overlaping segments","tooShort":"Segment is too short"},"cs":{"warnings":"Varování","close":"Zavřít","overlap":"Překrývající se segmenty","tooShort":"Segment je příliš krátký"}}')
  delete Component.options._Ctor
}
